export const reportSteps = [
  {
    target: ".j_rep_fetch",
    content: "Click here to fetch the latest reports from the system.",
    placement: "left",
  },
  {
    target: ".j_rep_aud",
    content: "Easily find all the activity regarding reports.",
    placement: "left",
  },
  {
    target: ".j_srch",
    content:
      "Filter results based on name, ID, or other attributes depending on the field.",
    placement: "bottom",
  },

  {
    target: ".j_fil",
    content: "Click here to apply filters and narrow down the report list.",
    placement: "left",
  },
  {
    target: ".j_rep_tog",
    content:
      "Use this switch to activate or deactivate the report distribution.",
    placement: "left",
  },
  {
    target: ".j_rep_dist",
    content: "Use this to send this report to various users.",
    placement: "left",
  },
  {
    target: ".j_rep_copy",
    content: "Use this to copy the sharable report link.",
    placement: "left",
  },
];
